<template>
	<div style="padding: 0px;">
		<el-form :inline="false" ref="devrule" label-width="120px" class="">
			<el-row>
				<el-col :span="12">
					<el-form-item label="所属校区" prop="org">
						<el-cascader style="width: 100%;" v-model="userorgid" @change="orgSelect"
							:options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-form-item>
				</el-col>
				<!-- <el-col :span="8">
					<el-form-item label="属性id前缀" prop="pointprefix">
						<el-input clearable :disabled="!editok" v-model="devinfo.pointprefix" maxlength="20"></el-input>
					</el-form-item>
				</el-col> -->
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-upload class="upload-demo" :limit="100" multiple drag :action="importuploadUrl" :data="extraData" 
				:before-upload="(file) => handleBeforeUpload(file) " accept=".xlsx" :headers="uploadheader" 
				:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList)">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				<div class="el-upload__tip" slot="tip">只能上传xlsx文件，且单个文件不超过1M</div>
			</el-upload>
		</div>
		<div style="color: #F56C6C;max-height: 300px;overflow: auto;margin-top: 10px;">
			<div v-html="errorinfo"></div>
		</div>
	</div>
</template>

<script> 
	//import {  } from '/static/apiUrl.js'
	import { baseUrl, nfsprefix, prefix } from '/public/baseUrl.js'
	export default {
		name : 'ImportDev',
		data() {
			return {
				editok: false,
				importuploadUrl : baseUrl + prefix + localStorage.getItem("citycode") + '/api/orgdev/importDevs',
				userorgid : [],
				disabled_cord: false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				extraData: {
					orgid : '',
				},
				errorinfo : '',
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			allOrgTree : {
				type : Array,
				required: true
			},
		},
		watch: {
		},
		methods: {
			closeDlg() {
				this.editok = false
				this.$emit("needRefrash",false,false)
			},
			orgSelect(val){
				if(val.length > 0){
					this.extraData.orgid = val[val.length - 1]
				}
			},
			handleBeforeUpload(file){
				this.errorinfo = ''
				if(this.userorgid.length == 0){
					this.$message.warning("请先选择所属校区");
					return false
				}
				const isLtSize = file.size / 1024 / 1024 < 10;
				if (!isLtSize) {
					this.$message.warning("导入文件大小不能超过 10MB!");
					return false;
				}
				return file
			},
			handleUploadSucc(response,file,fileList){
				if(0 == response.code){
					this.$message({
						showClose: true,
						message: "导入完成",
						type: 'success'
					});
					if(response.message){
						this.errorinfo += response.message.replace(";","<br>").replaceAll("；","<br/>")
					}
				}else{
					this.$message.error(response.message)
				}
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>